
; (function () {


    var MoveSinglePatientChartFolderToOtherUsersRoutes = [
        {
            "name": "Patient_Chart_Folder_Move_This_Folders_To_Other_Users_Popup",
            "templateUrl": "<div emr-patient-chart-folder-move-this-folders-to-other-users-popup></div>",
            "RoutingNumber": 3389,
            files: [
                "AngularScripts/MoveSinglePatientChartFolderToOtherUsers/Services/MoveSingleChartFoldersToOtherUsersService.js",
                "AngularScripts/MoveSinglePatientChartFolderToOtherUsers/Directives/PatientChartFolderMoveThisFoldersToOtherUsersPopupDirective.js"
            ]
        },
    ];



    angular.module('EMR.MoveSinglePatientChartFolderToOtherUsersModule', [])
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(MoveSinglePatientChartFolderToOtherUsersRoutes, $stateProvider);
            }]);
})();